import { render, staticRenderFns } from "./AddRoom.vue?vue&type=template&id=35f77979&scoped=true"
import script from "./AddRoom.vue?vue&type=script&lang=js"
export * from "./AddRoom.vue?vue&type=script&lang=js"
import style0 from "./AddRoom.vue?vue&type=style&index=0&id=35f77979&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f77979",
  null
  
)

export default component.exports